define.alias("checkout/components/seamless-checkout-table/line-item-section", "calendar/components/seamless-checkout-table/line-item-section");